import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/Dashboard.css";

const Dashboard = ({ onLogout }) => {
  const [profilePicture, setProfilePicture] = useState("");
  const username = localStorage.getItem("username");

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await axios.get(
          "http://35.192.131.111/user/my_profile/",
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`, // 필요시 토큰 추가
            },
          }
        );
        setProfilePicture(response.data.profile_picture); // 서버에서 받아온 프로필 이미지 URL 설정
      } catch (error) {
        console.error("Error fetching profile data:", error);
      }
    };

    fetchProfile();
  }, []);

  return (
    <section id="dashboard">
      <div className="dashboard-container">
        <div className="dashboard-Profile">
          <h1>{username}</h1>
          <img src={profilePicture || "./image/프로필.png"} />
        </div>
        <p>일반회원</p>
        <div className="dashboard-Button">
          <button className="dashboard-link">쪽지함</button>
          <button className="dashboard-link">프로필</button>
          <button className="dashboard-link">내정보</button>
          <button onClick={onLogout} className="dashboard-LogOutlink">
            로그아웃
          </button>
        </div>
      </div>
    </section>
  );
};

export default Dashboard;
